import PrivateNetworkClient from "helpers/privateNetwork";

const RoleList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/role/roleList", formData);
  return data;
}

const AddRole = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/addRole", formData);
  return data;
}

const EditRole = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.put("/editRole", formData);
  return data;
}

const RoleById = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/role/${id}`);
  return data;
}

const DeleteRoleById = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.delete(`/role/${id}`);
  return data;
}

const statusRole = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.put(`/role/changeStatus/${id}`);
  return data;
}
export {
  RoleList,
  AddRole,
  RoleById,
  DeleteRoleById,
  EditRole,
  statusRole
}